import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Font autoospitati: vengono impacchettati nel bundle e serviti dal nostro
// dominio, quindi passano la Content Security Policy (default-src 'self').
// Figtree = testo corrente, Nunito = titoli (.font-display).
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "@fontsource/nunito/900.css";

import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/registerServiceWorker";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Visual Viewport API: quando la tastiera si apre (il viewport visivo si restringe),
// riporta in vista il campo attivo così non resta nascosto dietro la tastiera.
// Attivo solo su dispositivi touch: nessun effetto su desktop.
if (window.visualViewport && window.matchMedia("(pointer: coarse)").matches) {
  let raf;
  window.visualViewport.addEventListener("resize", () => {
    const el = document.activeElement;
    if (el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() =>
        el.scrollIntoView({ block: "center", behavior: "smooth" })
      );
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Aggiornamenti automatici della PWA (attivo solo in produzione)
registerServiceWorker();
